module.exports = __webpack_public_path__ + "a9afa812366f48060ea87f71af7ff618.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/bn.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/bn.svg
// module chunks = 0